module.exports = __webpack_public_path__ + "static/media/LRLE01.66109699.jpg";